import { useEffect, useState } from "react";
import { Share, SquarePlus, Download, X, MoreVertical, MonitorDown } from "lucide-react";
import { isIOS, isStandalone, getInstallPrompt, onInstallPrompt, takeInstallPrompt } from "@/lib/push";

const KEY = "etm-install-card-hidden";

const detect = () => {
  const ua = navigator.userAgent;
  if (isIOS() || (navigator.platform === "MacIntel" && navigator.maxTouchPoints > 1)) return "ios";
  if (/android/i.test(ua)) return "android";
  if (/safari/i.test(ua) && !/chrome|chromium|edg/i.test(ua)) return "mac-safari";
  if (/firefox/i.test(ua)) return "firefox";
  return "desktop";
};

const STEPS = {
  ios: <>Dans Safari, touchez <Share size={14} className="inline text-[#F8C872]" /> <b>Partager</b>, puis <SquarePlus size={14} className="inline text-[#F8C872]" /> <b>Sur l'écran d'accueil</b>, puis <b>Ajouter</b>.</>,
  android: <>Touchez le menu <MoreVertical size={14} className="inline text-[#F8C872]" /> de Chrome, puis <b>Installer l'application</b> (ou <b>Ajouter à l'écran d'accueil</b>).</>,
  "mac-safari": <>Dans Safari, menu <b>Fichier</b> › <b>Ajouter au Dock</b>.</>,
  firefox: <>Ouvrez enjoythismoment.fr avec <b>Chrome</b> ou <b>Edge</b> pour l'installer sur votre ordinateur.</>,
  desktop: <>Cliquez sur l'icône <MonitorDown size={14} className="inline text-[#F8C872]" /> à droite de la barre d'adresse, puis <b>Installer</b>.</>,
};

export const InstallCard = () => {
  const [prompt, setPrompt] = useState(getInstallPrompt());
  const [hidden, setHidden] = useState(() => isStandalone() || !!localStorage.getItem(KEY));
  const platform = detect();
  useEffect(() => onInstallPrompt(setPrompt), []);
  if (hidden) return null;
  const close = () => { localStorage.setItem(KEY, "1"); setHidden(true); };
  const install = async () => { const p = takeInstallPrompt(); setPrompt(null); if (!p) return; try { await p.prompt(); const r = await p.userChoice; if (r.outcome === "accepted") close(); } catch { /* prompt already used */ } };
  return (
    <div data-testid="install-card" className="card-dark fade-up relative mx-5 mt-6 overflow-hidden p-5 md:mx-0">
      <button data-testid="install-card-close" aria-label="Masquer" onClick={close} className="absolute right-3 top-3 text-[#F7F4EE]/50 hover:text-[#F7F4EE]"><X size={16} /></button>
      <div className="flex items-start gap-4 pr-4">
        <img src="/img/icon-192.png" alt="" className="h-14 w-14 shrink-0 rounded-[14px] border border-[#E6A45D]/40" />
        <div className="min-w-0">
          <p className="text-sm font-semibold text-[#F8C872]">Installez l'application</p>
          <p className="mt-1 text-xs leading-relaxed text-[#F7F4EE]/75">Retrouvez vos Instants en un geste sur votre téléphone, tablette ou ordinateur, en plein écran, avec les notifications.</p>
        </div>
      </div>
      {prompt ? (
        <button data-testid="install-card-button" onClick={install} className="btn-gold mt-4 h-11 w-full text-xs"><Download size={15} />Installer l'application</button>
      ) : (
        <p data-testid="install-card-steps" className="mt-4 rounded-[14px] bg-[#090806] p-3 text-xs leading-relaxed text-[#F7F4EE]/85">{STEPS[platform]}</p>
      )}
    </div>
  );
};
